module.exports = __webpack_public_path__ + "assets/img/quick-start-en.34fe8659.png";